import { Route } from 'types/route.type';
import BluViuNutrition from 'views/bluviu-nutrition/components/bluviu-nutrition';
import EditCalibration from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/edit-calibration';

export const routes: Route[] = [
  {
    path: '/bluviu-nutrition/:tab/:globalSiteId?/',
    component: BluViuNutrition,
    id: 'bluViuNutrition.navigation.listCalibrations',
  },
  {
    path: '/bluviu-nutrition/:tab(calibrations)/:globalSiteId/:calibrationType/:calibrationId',
    component: EditCalibration,
  },
];
